import decode from "jwt-decode";

const decodeToken = tkn => {
  if (tkn) {
    try {
      return decode(tkn);
    } catch (e) {
      return undefined;
    }
  }
  return undefined;
};

export default decodeToken;
